(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('stepIndicator', {
            templateUrl: 'app/components/step-indicator/step-indicator.html',
            controller: stepIndicatorController,
            bindings: {
                steps: '<',
                currentStep: '<'
            },
            controllerAs: 'vm'
        });

    function stepIndicatorController() {
        var vm = this;

        vm.$onInit = init;

        function init() {
            vm.stepArray = new Array(vm.steps);
        }
    }

})();
